import { useDeploymentTracker } from '../Components/DeploymentTrackerContext';
import { useEffect } from 'react';

export class DeploymentTrackerService {
  private static instance: DeploymentTrackerService;
  private startMonitoringCallback: ((id: string) => void) | null = null;
  private stopMonitoringCallback: (() => void) | null = null;

  private constructor() {}

  public static getInstance(): DeploymentTrackerService {
    if (!DeploymentTrackerService.instance) {
        DeploymentTrackerService.instance = new DeploymentTrackerService();
    }
    return DeploymentTrackerService.instance;
  }

  public registerCallbacks(
    startMonitoring: (id: string) => void,
    stopMonitoring: () => void
  ) {
    this.startMonitoringCallback = startMonitoring;
    this.stopMonitoringCallback = stopMonitoring;
  }

  public monitorDeployment(deploymentId: string) {
    if (this.startMonitoringCallback) {
      this.startMonitoringCallback(deploymentId);
    } else {
      console.warn('Deployment monitoring not initialized');
    }
  }

  public stopMonitoring() {
    if (this.stopMonitoringCallback) {
      this.stopMonitoringCallback();
    }
  }
}

// Hook to use with components that need to trigger deployment monitoring
export const useDeploymentService = () => {
  const { startMonitoring, stopMonitoring } = useDeploymentTracker();
  const deploymentService = DeploymentTrackerService.getInstance();

  useEffect(() => {
    // Register the callbacks from the context with the service
    deploymentService.registerCallbacks(startMonitoring, stopMonitoring);
    
    // Cleanup function
    return () => {
      deploymentService.registerCallbacks(() => {}, () => {});
    };
  }, [startMonitoring, stopMonitoring]);

  return deploymentService;
};